export default __webpack_public_path__ + "static/media/cursorWrapper.96eb46e4.svg";